


























































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { IPartner } from "@/interface";

@Component
export default class PartnerModal extends Vue {
  @Prop({ default: false }) readonly showModal!: boolean;
  @Prop({ required: true }) readonly partners!: Array<IPartner>;

  private selectedPartner: number | null = null;

  private handleSelect(): void {
    if (!this.selectedPartner) return;
    const selectedPartner: IPartner | undefined = this.partners.find(
      partner => partner.id === this.selectedPartner
    );
    if (selectedPartner !== undefined) {
      localStorage.setItem("partnerId", `${selectedPartner.id}`);
      localStorage.setItem("partnerCode", `${selectedPartner.code}`);
    }
    this.$router.push({
      name: "UsersOverview"
    });
  }

  @Watch("partners")
  partnersChanged(newPartners: Array<IPartner>): void {
    if (newPartners.length > 0 && newPartners[0].id) {
      this.selectedPartner = newPartners[0].id;
    }
  }
}
